export const LINE_OPTIONS$1 = {};
